<template>
    <section>
        <GChart
                type="GeoChart"
                :data="chartData"
                :options="chartOptions"
                :settings="{ packages: ['geochart'], mapsApiKey: 'AIzaSyD-9tSrke72PouQMnMX-a7eZSW0jkFMBWY' }"
        />
    </section>
</template>

<script>
    import { GChart } from 'vue-google-charts'

    export default {
        name: 'CountryChart',
        components: {
            GChart
        },
        props: ['chartData'],
        watch: {
            chartData (d) {
                console.log(d)
            }
        },
        data () {
            return {
                chartOptions: {
                    colorAxis: {
                        colors: ['#D4EFC2', '#91c954']
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CountryChart.vue